// @flow
import { authenticatedFetch } from '../../../api/request';

export default async function getNotificationCounts() {
    const url = `/v5/notifications/counts`;
    return await authenticatedFetch(url);
}
